import { maxLength, minLength, required, TextInput, useRecordContext, useTranslate } from 'react-admin';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import ContractorLogoInput from '@/components/contractors/ContractorLogoInput.jsx';
import { RetailChainLogoField } from '@/components/retailChain/fields/RetailChainLogoField.jsx';
import { noSpecialCharacters } from '@/components/global/validators/customValidators.jsx';
import { retailChainSectionStyles } from '@/themes/commonStyles/retailChainForm.js';
import { isAllowedLogoFile, LOGO_MAX_BYTES } from '@/components/retailChain/validators/retailChainValidators.js';

const StyledSection = styled(Box)(retailChainSectionStyles);

export const RetailChainBasicInfo = () => {
    const translate = useTranslate();
    const record = useRecordContext();
    const hasExistingLogo = Boolean(record?.currentLogo || record?.logo);

    const validateLogoFormat = file => {
        const files = Array.isArray(file) ? file : [file];
        if (files.every(item => !item || isAllowedLogoFile(item))) {
            return undefined;
        }

        return translate('resources.retailChain.validation.logoFormat');
    };

    return (
        <StyledSection>
            <Typography variant='h5'>{translate('resources.retailChain.labels.basicInfo')}</Typography>
            <TextInput
                source='name'
                label={translate('resources.retailChain.fields.name')}
                validate={[
                    required(translate('common.validation.required')),
                    minLength(3, translate('common.validation.minLength', { count: 3 })),
                    maxLength(200, translate('common.validation.maxLength', { count: 200 })),
                    noSpecialCharacters,
                ]}
                fullWidth
            />
            <ContractorLogoInput
                source='logo'
                record={record}
                maxBytes={LOGO_MAX_BYTES}
                maxSizeMessage={translate('resources.retailChain.validation.logoTooLarge')}
                instructionText={translate('resources.retailChain.validation.logoFormatsHint')}
                validate={validateLogoFormat}
                existingPreview={hasExistingLogo ? <RetailChainLogoField width={160} height={100} /> : null}
            />
            <TextInput
                source='description'
                label={translate('resources.retailChain.fields.description')}
                validate={[maxLength(200, translate('common.validation.maxLength', { count: 200 }))]}
                fullWidth
            />
        </StyledSection>
    );
};

RetailChainBasicInfo.propTypes = {};
